<script setup>
import { computed, nextTick, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStoreGetters, useStore } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const emit = defineEmits(['close']);
const { t } = useI18n();
const store = useStore();
const getters = useStoreGetters();

const task = ref({});
const dialogRef = ref(null);
const isOpen = ref(false);
const uiFlags = getters['wgptTasks/getUIFlags'];

const description = computed(() => {
  return `${t('WGPT_TASKS.DELETE.CONFIRM.MESSAGE')} ${task.value.name}?`;
});

const open = targetTask => {
  task.value = targetTask;
  isOpen.value = true;
  nextTick(() => {
    if (!dialogRef.value) return;
    dialogRef.value.open();
  });
};

const close = () => {
  dialogRef.value.close();
  isOpen.value = false;
  emit('close');
};

const handleDialogConfirm = async () => {
  try {
    await store.dispatch('wgptTasks/delete', task.value.id);
    useAlert(t('WGPT_TASKS.DELETE.API.SUCCESS_MESSAGE'));
    close();
  } catch (error) {
    const errorMessage =
      error?.response?.message || t('WGPT_TASKS.DELETE.API.ERROR_MESSAGE');
    useAlert(errorMessage);
  }
};

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    :title="t('WGPT_TASKS.DELETE.CONFIRM.TITLE')"
    :description="description"
    :confirm-button-label="t('WGPT_TASKS.DELETE.CONFIRM.YES')"
    :cancel-button-label="t('WGPT_TASKS.DELETE.CONFIRM.NO')"
    :is-loading="uiFlags.isDeleting"
    @confirm="handleDialogConfirm"
  />
</template>
